import { Capacitor } from '@capacitor/core';

/**
 * Get the API base URL, handling native Capacitor apps.
 * Native apps need absolute URLs since WebView runs at capacitor://localhost
 */
export const getApiUrl = () => {
  if (Capacitor.isNativePlatform()) {
    return 'https://protrener.app/api';
  }
  return process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');
};

export const API_URL = getApiUrl();
